<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="chap6">The Tale of Old Venn</h1>
<blockquote>
<p class="noind" style="margin-top:20px;">The chain of deconstructions cannot, of course, be contained here: for if the image functions as a violent displacement from the origin, life, or meaning to which it apparently refers, there is a second fundamental question raised more or less explicitly in each of these essays. What about my text as the image of the image: what about the possibility of reading …?</p>
</blockquote>
<p class="right">—<span class="small">CAROL JACOBS</span></p>
<p class="right"><i>The Dissimulating Harmony</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 12-chap6.vue?27829bf5